import { createFileRoute, redirect } from '@tanstack/react-router'
import type { JSX } from 'react'

import { VerifyEmailForm } from '@/components/auth/verify-email-form'
import { getVerificationState } from '@/lib/auth/verification'

export const Route = createFileRoute('/_public/verify-email')({
  beforeLoad: () => {
    const { token, step } = getVerificationState()
    if (!token) throw redirect({ to: '/login' })
    // Si el paso ya avanzó a phone, redirigir (el guard del padre también lo hace,
    // pero este cierra el caso si se navega directamente a la URL)
    if (step === 'phone') throw redirect({ to: '/verify-phone' })
  },
  component: VerifyEmailPage,
})

function VerifyEmailPage(): JSX.Element {
  return <VerifyEmailForm />
}
